import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import Button from 'Components/UI/Button';
import AchTransferModal from 'Components/Modals/AccountTransfer';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2),
  },
  title: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  table: {
    marginLeft: theme.spacing(2),
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  column: {
    flex: 1,
    textAlign: 'right',
  },
  transferTypePill: {
    borderRadius: theme.radius.lg,
    backgroundColor: theme.palette.facet.accentGreen2,
    minWidth: '100px',
    textAlign: 'center',
  },
  transferType: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  date: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
  },
  amount: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
  },
  statusComment: {
  },
  statusCommentText: {
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.facet.darkGray,
    maxWidth: '160px',
  },
  status: {
    fontWeight: theme.typography.fontWeightBold,
  },
});

const getStatusComponent = (classes, row) => {
  return (
    <Button
      className={classes.transferTypePill}
      style={{
        backgroundColor: row.statusColors.backgroundColor,
      }}
      onClick={row.onClick}
    >
      <Typography
        className={classes.transferType}
        variant="h6"
        color={row.statusColors.textColor}
      >
        {row.status}
      </Typography>
    </Button>
  );
};

const View = ({
  classes, rows, modalState, amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} debugColor="chartreuse" {...amplitudeRootNodeProps}>
      <Typography
        variant="h3"
        color="primary"
        className={classes.title}
      >
        Transfers
      </Typography>
      <AchTransferModal
        closeModal={modalState.onClose}
        isOpen={modalState.show}
        accountTransferLink={modalState.url}
      />
      <div className={classes.table}>
        {rows.map(row => (
          <div className={classes.row}>
            <div className={classes.column}>
              {getStatusComponent(classes, row)}
            </div>
            <div className={classes.column} style={{ flex: 2 }}>
              <Typography
                className={classes.date}
                variant="h6"
              >
                {row.transferDate}
              </Typography>
            </div>
            <div className={classes.column}>
              <Tooltip title={row.amount} arrow placement="top-end">
                <Typography
                  className={classes.amount}
                  variant="h6"
                >
                  {row.amount}
                </Typography>
              </Tooltip>
            </div>
            <div className={classes.column}>
              <Typography
                className={classes.status}
                style={{
                  color: row.transferColors.textColor,
                }}
                variant="h6"
              >
                {row.transferType}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  rows: PropTypes.array,
  modalState: PropTypes.object.isRequired,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
};
View.defaultProps = {
  rows: [],
};

export default withStyles(styles)(View);
